<div class="mobile-table-container">
  @if (!leadsCount) {
    <div class="empty-message">
      <h2 fiTranslation="SEARCH_MESSAGE_NO_RESULT_HEADLINE"></h2>
      <span fiTranslation="SEARCH_MESSAGE_NO_RESULT_TEXT"></span>
    </div>
  }

  @for (lead of contactLeads; track trackByLeadId(i, lead); let i = $index) {
    @if (lead.requiresConfirmation) {
      <div class="mobile-duplicate-row">
        <div class="duplicate-text">
          <span class="bold" fiTranslation="REQUEST_CREATE_CONTACT_HEADLINE_NEW_REQUEST"></span>&nbsp;
          <span class="bold" fiMaskSearched="{{ lead.Lead.DateFormattedId }}"
          [categoryName]="'Number'">{{ lead.Lead.DateFormattedId }}</span>
          - <span fiTranslation="ACTION_LEAD_FORWARD_OTHER_MANDANT_TEXT"></span>
        </div>
        <div class="duplicate-buttons">
          <button [class.dense]="compactView$ | async" class="f_requires-confirmation-reject reject btn"
            (click)="rejectAssignment(i)" fiTranslation="REQUEST_OVERVIEW_ACTION_DECLINE_ENQUIRY">
          </button>
          <button [class.dense]="compactView$ | async" class="f_requires-confirmation-accept accept btn"
            (click)="confirmAssignment(i)" fiTranslation="REQUEST_OVERVIEW_ACTION_ACCEPT_ENQUIRY">
          </button>
        </div>
      </div>
    }
    @if (!lead.requiresConfirmation) {
      <div class="mobile-row" [class.unread]="false">
        <div class="mobile-row-head" (click)="toggleExpandedLead(lead)">
          <div class="image-container">
            <img alt="Mobile row" [src]="leadHelper.getAssetImage(lead.Lead.LeadTypeId, true)">
          </div>
          <div class="titles">
            <div class="address is-html-snippet" [innerHTML]="getAddress(lead).address">
            </div>
            <div class="meta">
              <span class="date">{{ getDate(lead) }}</span>
              @if (getContactName(lead); as contactName) {
                <span class="contact-name">{{ contactName }}</span>
              }
            </div>
          </div>
          <img src="assets/icons/arrow-up.svg" alt="Arrow" class="arrow" [class.expanded]="expandedLeads.has(lead)">
        </div>
        @if (expandedLeads.has(lead)) {
          <div class="mobile-row-content">
            <div class="contact-data">
              <div fiTranslation="REQUEST_OVERVIEW_COLUMNS_HEADLINE_COUNTRY"></div>
              <div>{{ lead?.Lead?.Address?.CountryCode ?? lead?.Lead?.Contact?.CountryCode }}</div>
            </div>
            <div class="contact-data">
              <div fiTranslation="REQUEST_OVERVIEW_COLUMNS_HEADLINE_CONTACT"></div>
              <div>
                @if (!lead.Lead.Contact?.Anonymized) {
                  {{ lead.Lead.Contact.FirstName }} {{ lead.Lead.Contact.LastName }}
                }
                @if (lead.Lead?.Contact?.Company) {
                  {{ lead.Lead?.Contact?.Company }}
                }
              </div>
            </div>
            <div class="contact-data">
              <div fiTranslation="REQUEST_OVERVIEW_COLUMNS_HEADLINE_STATUS"></div>
              <div>
                {{ lead.Lead.StatusText }}
              </div>
            </div>
            <div class="contact-data">
              <div fiTranslation="REQUEST_OVERVIEW_COLUMNS_HEADLINE_RESPONSIBLE"></div>
              <div>
                {{ lead.Lead.EditorName }}
              </div>
            </div>
            <div class="contact-data">
              <div fiTranslation="REQUEST_OVERVIEW_COLUMNS_HEADLINE_DUE_DATE"></div>
              <div>
                <fi-lead-status [leadData]="lead" [compactView]="true" [isOverview]="true"
                  [dense]="true"
                  [moveIndicatorToEnd]="true"
                [unread]="false"></fi-lead-status>
              </div>
            </div>
          </div>
        }
        @if (expandedLeads.has(lead)) {
          <button class="mobile-open-lead-btn"
            (click)='lead.isDuplicate ? onDuplicateClick(i) : openLeadDetails(lead.Lead.Id, $event.ctrlKey)'>
            @if (!lead.isDuplicate) {
              <span fiTranslation="REQUEST_OVERVIEW_DETAIL"></span>
            }
            @if (lead.isDuplicate) {
              <span fiTranslation="ALT_TEXT_DUPLICATE_CHECK"></span>
            }
            <img alt="arrow" src="assets/icons/arrow-corner.svg">
          </button>
        }
      </div>
    }
  }
  @if (leadsCount && contactLeads?.length) {
    <div class="pagination-footer mobile">
      <span fiTranslation="REQUEST_OVERVIEW_FILTER_PAGINATION_1"></span>
      &nbsp; ({{ visibleLeadsCount }}&nbsp;
      <span fiTranslation="REQUEST_OVERVIEW_FILTER_PAGINATION_2"></span>&nbsp;
      {{ leadsCount }})
      <button class="left-btn" [disabled]="(filters.pageNumber ?? 0) <= 0" (click)="prevPage()">
        <img src="assets/icons/pagination-arrow.svg" alt="left">
        <span class="u-hidden-visually" fiTranslation="ALT_TEXT_PAGINATION_PREVIOUS"></span>
      </button>
      <button class="right-btn" [disabled]="(filters.pageNumber ?? 0) >= pagesCount - 1" (click)="nextPage()">
        <img src="assets/icons/pagination-arrow.svg" alt="right">
      </button>
    </div>
  }


</div>
